
import { useMutation, useQuery } from "react-query"
import { useToast } from "../../../hook/usetoast";
import DataService from '../../../config/DataServices'
import { queryClient } from "../../../config";

const { postRequest, getRequest } = DataService()



export const useGetBuyVRS = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/auth/fgkjnkj", { ...data })
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }
        }
    })
}


export const useGetPillPrice = () => {

    return useQuery({
        queryKey: ["pill-price"],
        queryFn: () => {
            return getRequest(`user/auth/getPillPrice`)
        },
        enabled: !!sessionStorage.getItem('user_JWT'),
    })
}

export const useGetCurrentPillPrice = () => {

    return useQuery({
        queryKey: ["current-price"],
        queryFn: () => {
            return getRequest(`user/auth/currentprice`)
        },
        enabled: !!sessionStorage.getItem('user_JWT'),
    })
}
export const useBuyToken = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/ico/buyToken", { ...data })
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }
            return toast.success(success?.message)
        }
    })
}


export const useCheckMinMax = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/ico/checkMinAndMax", { ...data })
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }
        }
    })
}


export const useICOStatus = () => {

    return useQuery({
        queryKey: ["ico-status"],
        queryFn: () => {
            return getRequest(`user/auth/site-settings`)
        },
    })
}


export const useGetTopUpVRS = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/auth/topvg", { ...data })
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }
        }
    })
}


export const useLevelTopUp = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/auth/adminPay", { ...data })
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }
            queryClient.refetchQueries("get-profile")
            return toast.success(success?.message)

        }
    })
}



export const useGetWithdrawVRS = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/auth/withdrawvrs", { ...data })
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }
        }
    })
}


export const useUserWithdraw = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/auth/withdrawStore", { ...data })
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }
            queryClient.refetchQueries("get-profile")  
            queryClient.refetchQueries("get-balance")  
            return toast.success(success?.message)
        }

    })
}


export const useWithdrawMinMax = () => {

    return useQuery({
        queryKey: ["withdraw-minmax"],
        queryFn: () => {
            return getRequest(`user/auth/getminmax`)
        },
    })
}